import React, { useState, useEffect } from 'react'
import {
  InputNumber,
  InputGroup,
  Input,
  IconButton,
  Icon,
  Grid,
  Row,
  Col,
  Panel,
  Table,
  SelectPicker,
  Checkbox,
} from 'rsuite'
import { isValidators } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import TooltipButton from '../../components/buttons/TooltipButton'
import { cloneDeep } from 'lodash'
import NumberFormat from 'react-number-format'

export default function ProgessProductForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  getValues,
  clearErrors,
  ...props
}) {
  // const [schema, setSchema] = useState(_schema)
  const [datalist, setDataList] = useState(cloneDeep(schema.values || []))
  const dataKey = 'datalist'
  const { Column, HeaderCell, Cell } = Table

  const onAddNewRow = (rowData) => {
    let arr = [...datalist]
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index]

      if (element.id == rowData.id) {
        // let date = new Date().getTime()
        let newId = `ADD_ID_${new Date().getTime()}`
        console.log('create add id ', newId)
        let data = {
          id: newId,
          expectedProduct: '',
          productType: 0,
          unit: '',
          result: '',
          enableDelete: true,
        }
        arr[index].children.push(data)
        break
      }
    }
    console.log('errors ', errors)
    console.log('after add ', arr)
    setDataList(arr)
    setValue(dataKey, arr)
  }

  const onChangeValue = (rowData, selectIndex, value, key) => {
    let arr = [...datalist]

    for (let index = 0; index < arr.length; index++) {
      const element = arr[index]

      if (element.id == rowData._parent.id) {
        for (let subIndex = 0; subIndex < element.children.length; subIndex++) {
          const subElement = element.children[subIndex]
          if (subElement.id == rowData.id) {
            arr[index].children[subIndex][key] = value
            console.log('value', value, 'key', key)
            if (key == 'productType' || key == 'notEffective') {
              arr[index].children[subIndex]['result'] = ''
              arr[index].children[subIndex]['unit'] = ''

              setValue(`${schema.result.name}_${selectIndex}`, '')
              setValue(`${schema.unit.name}_${selectIndex}`, '')
            }

            setDataList(arr)
            setValue(dataKey, arr)
            break
          }
        }
        break
      }
    }
  }

  const onDeleteRow = (rowData) => {
    let arr = [...datalist]
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index]

      if (element.id == rowData._parent.id) {
        for (let subIndex = 0; subIndex < element.children.length; subIndex++) {
          const subElement = element.children[subIndex]
          if (subElement.id == rowData.id) {
            arr[index].children.splice(subIndex, 1)

            setDataList(arr)
            setValue(dataKey, arr)
            break
          }
        }
        break
      }
    }
  }

  const quantitative = (rowData, index) => {
    return (
      <Controller
        key={`${schema.result.name}_${index}`}
        name={`${schema.result.name}_${index}`}
        control={control}
        rules={rowData.notEffective ? {} : isValidators(schema.result.validators)}
        defaultValue={rowData.result}
        disabled={rowData.notEffective}
        render={(props) => {
          return (
            // <InputNumber
            //   value={props.value}
            //   placeholder={schema.result.hint}
            //   disabled={rowData.notEffective}
            //   onChange={(value) => {
            //     props.onChange(value)
            //     onChangeValue(rowData, index, value, 'result')
            //   }}
            // />
            <NumberFormat
              className="rs-input"
              disabled={rowData.notEffective}
              placeholder={schema.result.hint}
              thousandSeparator={true}
              value={props.value}
              onValueChange={(value) => {
                props.onChange(value.floatValue)
                onChangeValue(rowData, index, value.floatValue, 'result')
              }}
            />
          )
        }}
      />
    )
  }

  const unitInput = (rowData, index) => {
    return (
      <Input
        key={`${schema.unit.name}_${index}`}
        name={`${schema.unit.name}_${index}`}
        placeholder={schema.unit.hint}
        defaultValue={rowData.unit}
        inputRef={register(isValidators(schema.unit.validators))}
        onChange={(value) => {
          onChangeValue(rowData, index, value, 'unit')
        }}
      />
    )
  }

  const expectedProductColumn = (rowData, index) => {
    if (rowData.labelName) {
      return rowData.labelName
    } else {
      return rowData.enableDelete ? (
        <div>
          {errors[`${schema.expectedProduct.name}_${index}`] && (
            <Row style={{ marginBottom: 10 }}>
              <ErrorMessage error={errors[`${schema.expectedProduct.name}_${index}`]} />
            </Row>
          )}
          <Input
            key={`${schema.expectedProduct.name}_${index}`}
            name={`${schema.expectedProduct.name}_${index}`}
            placeholder={schema.expectedProduct.hint}
            defaultValue={rowData.expectedProduct}
            inputRef={register(isValidators(schema.expectedProduct.validators))}
            // rows={3}
            // componentClass="textarea"
            onChange={(value) => {
              onChangeValue(rowData, index, value, 'expectedProduct')
            }}
          />
        </div>
      ) : (
        <>{rowData.expectedProduct}</>
      )
    }
  }

  const productTypeColumn = (rowData, index) => {
    if (typeof rowData.productType !== 'undefined' && rowData.enableDelete) {
      return (
        <SelectPicker
          data={schema.productTypeOptions}
          searchable={false}
          value={rowData.productType}
          onChange={(value) => {
            onChangeValue(rowData, index, value, 'productType')
          }}
        />
      )
    } else if (typeof rowData.productType !== 'undefined') {
      return (
        <>
          {schema.productTypeOptions.map((item) => {
            if (item.value == rowData.productType) {
              return item.label
            }
          })}
        </>
      )
    }
  }

  const notEffectiveCheckbox = (rowData, index) => {
    return (
      <Checkbox
        checked={rowData.notEffective}
        onChange={(_, checked) => onChangeValue(rowData, index, checked, 'notEffective')}
      >
        ไม่เกิดผลในครั้งนี้
      </Checkbox>
    )
  }

  return (
    <div>
      <Row>
        <Panel bodyFill>
          <Grid fluid>
            <Controller
              key={dataKey}
              name={dataKey}
              control={control}
              defaultValue={datalist || []}
              render={(props) => {
                return (
                  <Table
                    isTree
                    defaultExpandAllRows
                    rowKey="id"
                    cellBordered
                    // height={400}
                    autoHeight
                    wordWrap
                    data={props.value || []}
                  >
                    <Column resizable width={500}>
                      <HeaderCell>{schema.columnText1}</HeaderCell>
                      <Cell>
                        {(rowData, index) => {
                          return expectedProductColumn(rowData, index)
                        }}
                      </Cell>
                    </Column>

                    <Column resizable width={140} align="center">
                      <HeaderCell>{schema.columnText2}</HeaderCell>
                      <Cell>
                        {(rowData, index) => {
                          return productTypeColumn(rowData, index)
                        }}
                      </Cell>
                    </Column>

                    <Column flexGrow={1}>
                      <HeaderCell>{schema.columnText3}</HeaderCell>
                      <Cell>
                        {(rowData, index) => {
                          return typeof rowData.expectedProduct !== 'undefined' ? (
                            <>
                              {rowData.productType == 1 ? (
                                <>
                                  {rowData.enableDelete ? (
                                    <Row>
                                      <Col xs={24} sm={16} md={16}>
                                        {errors[`${schema.result.name}_${index}`] && (
                                          <Row style={{ marginBottom: 10 }}>
                                            <ErrorMessage
                                              error={errors[`${schema.result.name}_${index}`]}
                                            />
                                          </Row>
                                        )}
                                        {quantitative(rowData, index)}
                                      </Col>
                                      <Col xs={24} sm={8} md={8}>
                                        {errors[`${schema.unit.name}_${index}`] && (
                                          <Row style={{ marginBottom: 10 }}>
                                            <ErrorMessage
                                              error={errors[`${schema.unit.name}_${index}`]}
                                            />
                                          </Row>
                                        )}
                                        {unitInput(rowData, index)}
                                      </Col>
                                    </Row>
                                  ) : (
                                    <>
                                      {errors[`${schema.result.name}_${index}`] && (
                                        <Row style={{ marginBottom: 10 }}>
                                          <ErrorMessage
                                            error={errors[`${schema.result.name}_${index}`]}
                                          />
                                        </Row>
                                      )}
                                      {!rowData.enableDelete &&
                                        notEffectiveCheckbox(rowData, index)}
                                      <InputGroup>
                                        {quantitative(rowData, index)}
                                        <InputGroup.Addon>
                                          <p>{rowData.unit}</p>
                                        </InputGroup.Addon>
                                      </InputGroup>
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {errors[`${schema.result.name}_${index}`] && (
                                    <Row style={{ marginBottom: 10 }}>
                                      <ErrorMessage
                                        error={errors[`${schema.result.name}_${index}`]}
                                      />
                                    </Row>
                                  )}
                                  {!rowData.enableDelete && notEffectiveCheckbox(rowData, index)}
                                  <Input
                                    key={`${schema.result.name}_${index}`}
                                    name={`${schema.result.name}_${index}`}
                                    placeholder={schema.result.hint}
                                    defaultValue={rowData.result}
                                    inputRef={
                                      rowData.notEffective
                                        ? register({ required: false })
                                        : register(isValidators(schema.result.validators))
                                    }
                                    rows={3}
                                    componentClass="textarea"
                                    disabled={rowData.notEffective}
                                    onChange={(value) => {
                                      onChangeValue(rowData, index, value, 'result')
                                    }}
                                  />
                                </>
                              )}
                            </>
                          ) : (
                            rowData.result
                          )
                        }}
                      </Cell>
                    </Column>
                    <Column width={90} align="center" fixed="right">
                      <HeaderCell></HeaderCell>
                      <Cell>
                        {(rowData) => {
                          if (rowData.enableDelete) {
                            return (
                              <TooltipButton
                                icon="trash"
                                tooltip={`ลบ${schema.buttonText || ''}`}
                                onClick={() => onDeleteRow(rowData)}
                              >ลบ</TooltipButton>
                            )
                          } else if (rowData.addLevel) {
                            return (
                              <TooltipButton
                                icon="plus"
                                tooltip={`เพิ่ม${schema.buttonText || ''}`}
                                onClick={() => onAddNewRow(rowData)}
                              >เพิ่ม</TooltipButton>
                            )
                          }
                        }}
                      </Cell>
                    </Column>
                  </Table>
                )
              }}
            />
          </Grid>
        </Panel>
      </Row>
    </div>
  )
}
